import React, { useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Payment from '../assets/images/Home/Payments.jpg';
import { toast } from 'react-toastify';

const PaymentSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const sessionId = localStorage.getItem("sessionid");
    const partnercode = localStorage.getItem("partnerCode");
    const currency = localStorage.getItem("currency") || "USD";
    const apiUrl = process.env.REACT_APP_BASE_URL; // Use the environment variable

    if (!sessionId) {
      toast.error("⚠️ No sessionId found in localStorage.");
      return;
    }

    console.log("🔍 Using sessionId:", sessionId);
    console.log("📝 Sending params:", { SessionId: sessionId, partnercode, currency });

    const confirmOrder = async () => {
      try {
        const response = await axios.post(
          `${apiUrl}ESIM/OrderSuccess?SessionId=${sessionId}&partnercode=${partnercode}&currency=${currency}`,
          {
            headers: {
              "Accept": "*/*",
            },
          }
        );

        if (response.data.isSuccess) {
          localStorage.setItem("orderTransaction", sessionId);
          toast.error(`✅ Order completed: ${response.data.message}`);
        } else {
          toast.error(`❌ Order failed: ${response.data.message}`);
        }
      } catch (err) {
        console.error("⚠️ Order error:", err);
        toast.error(`🚨 Order error: ${err?.response?.data?.message || err.message}`);
      }
    };

    confirmOrder();

    // ⏳ Set a timer to redirect after 5 seconds
    const timer = setTimeout(() => {
      navigate("/addmorebalance");
    }, 5000);

    return () => clearTimeout(timer); // Cleanup timeout on unmount
  }, [navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 text-center px-4">
  <div className="bg-white p-6 rounded-2xl shadow-lg max-w-md w-full">
    <img src={Payment} alt="Payment Success" className="mx-auto mb-6 rounded-xl shadow-md w-full h-auto max-h-96 object-contain"/>
    <h1 className="text-2xl font-bold text-green-600 mb-2">Payment Successful!</h1>
    <p className="text-gray-700 text-base">Redirecting to Add More Balance page...</p>
  </div>
</div>

  );
};

export default PaymentSuccess;